// Autogenerated file
export const paymentPeriodTypesEnum = {
    InCalendarDays: "InCalendarDays",
    InBankingDays: "InBankingDays",
};
export const paymentPeriodTypes = [
    { label: "В календарных днях", value: "InCalendarDays" },
    { label: "В банковских днях", value: "InBankingDays" },
];
